<template>
  <b-button @click="$emit('click', $event)" size="sm" variant="secondary" v-b-tooltip.hover :title="showToolTip ? 'Экспорт в Excel' : ''"><i class="fa fa-file-excel-o"></i></b-button>
</template>

<script>

export default ({
  name: "button-excel",
  computed: {
    showToolTip() {
      return this.$store.state.userSettings.showTooltips;
    }
  }
})
</script>
